import PortableTextPlusBlogPost from "../portable-text-plus-blog-post";
import classNames from "classnames";

export default function PostBody({ content }) {
  return (
    <div
      className={classNames(
        "prose first-letter:font-semibold first-letter:text-4.5xl first-letter:lg:text-6xl",
        "first-letter:leading-tight first-letter:mx-0.5"
      )}
    >
      <PortableTextPlusBlogPost value={content} />
    </div>
  );
}
